import "./App.css";
import styled from "styled-components";
import { moneyPyramid } from "./dummyData";
import { data } from "./dummyData";
import { useState, useEffect, useContext } from "react";
import Quiz from "./components/Quiz";
import Timerr from "./components/Timerr";
import User from "./components/User";
import Congrat from "./components/Congrat";
import { AuthContext } from "./utils/context/AuthContext/AuthContext";
import { renderResult } from "./apiCalls";

const Container = styled.div`
  background-color: #020230;
  display: flex;
  color: white;
  height: 100vh;
`;

const Pyramid = styled.div`
  width: 25%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
`;

const MoneyList = styled.div`
  list-style: none;
  padding: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media only screen and (max-width: 767px) {
    padding: 0px;
    width: 100%;
  }
`;

const MoneyListItems = styled.li`
  display: flex;
  align-items: center;
  padding: 5px;
  border-radius: 5px;
`;
const MoneyListItemsActive = styled(MoneyListItems)`
  background: green;
  font-weight: 500;
`;

const MoneyListItemsNumber = styled.span`
  font-size: 18px;
  font-weight: 400;
  width: 20%;
  @media only screen and (max-width: 767px) {
    font-size: 12px;
    font-weight: 200;
  }
`;
const MoneyListItemsamount = styled.span`
  font-size: 20px;
  font-weight: 400;

  @media only screen and (max-width: 767px) {
    font-size: 12px;
    font-weight: 200;
  }
`;

const Main = styled.div`
  width: 75%;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0), #020230),
    url("img/bg.jpg") center;
  display: flex;
  flex-direction: column;
  @media only screen and (max-width: 767px) {
    width: 65%;
  }
`;

const Top = styled.div`
  height: 50%;
  position: relative;
  @media only screen and (max-width: 767px) {
    height: 20%;
  }
`;
const Timer = styled.div`
  color: white;
  width: 70px;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 5px solid white;
  border-radius: 50%;
  font-size: 30px;
  font-weight: 700;
  position: absolute;
  bottom: 10px;
  left: 80px;
`;
const Bottom = styled.div`
  height: 50%;
  @media only screen and (max-width: 767px) {
    height: 80%;
  }
`;

const EndText = styled.h1`
  position: relative;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  @media only screen and (max-width: 767px) {
    font-size: 18px;
  }
`;

function App() {
  const [questionNumber, setQuestionNumber] = useState(1);
  const [stop, setStop] = useState(false);
  const [earned, setEarned] = useState("$ 0");
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [congrat, setCongrat] = useState(false);
  const { user } = useContext(AuthContext);

  useEffect(() => {
    questionNumber > 1 &&
      setEarned(moneyPyramid.find((m) => m.id === questionNumber - 1).amount);
  }, [questionNumber]);

  const idUser = user?.savedUser._id;

  return (
    <Container>
      {congrat ? (
        (renderResult({ id: idUser, score: earned }),
        (<Congrat user={user} idUser={idUser} />))
      ) : (
        <>
          {user?.message ? (
            <>
              <Main>
                {stop ? (
                  (renderResult({ id: idUser, score: earned }),
                  (<EndText>You earned : {earned}</EndText>))
                ) : (
                  <>
                    <Top>
                      <Timer>
                        <Timerr
                          setStop={setStop}
                          questionNumber={questionNumber}
                          selectedAnswer={selectedAnswer}
                        />
                      </Timer>
                    </Top>
                    <Bottom>
                      <Quiz
                        data={data}
                        questionNumber={questionNumber}
                        setQuestionNumber={setQuestionNumber}
                        setStop={setStop}
                        selectedAnswer={selectedAnswer}
                        setSelectedAnswer={setSelectedAnswer}
                        congrat={congrat}
                        setCongrat={setCongrat}
                      />
                    </Bottom>
                  </>
                )}
              </Main>
              <Pyramid>
                <MoneyList>
                  {moneyPyramid.map((m) => (
                    <>
                      {questionNumber === m?.id ? (
                        <MoneyListItemsActive key={m?.id}>
                          <MoneyListItemsNumber>{m?.id}</MoneyListItemsNumber>
                          <MoneyListItemsamount>
                            {m?.amount}
                          </MoneyListItemsamount>
                        </MoneyListItemsActive>
                      ) : (
                        <MoneyListItems key={m?.id}>
                          <MoneyListItemsNumber>{m?.id}</MoneyListItemsNumber>
                          <MoneyListItemsamount>
                            {m?.amount}
                          </MoneyListItemsamount>
                        </MoneyListItems>
                      )}
                    </>
                  ))}
                </MoneyList>
              </Pyramid>
            </>
          ) : (
            <User />
          )}
        </>
      )}
    </Container>
  );
}

export default App;
